import { NavigationEntry } from "./navigation-entry";
import React, { useState, useLayoutEffect } from "react";
import { SimpleCardProperties } from "./simple-card-properties";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEuroSign, faUserTie, faCheckSquare, faClock, faEye } from '@fortawesome/free-solid-svg-icons';

const Home = React.lazy(() => import("../components/Home/Home"));
const About = React.lazy(() => import("./../components/About/About"));
const Contact = React.lazy(() => import("./../components/Contact/Contact"));

export class Provider {
    public static readonly navigationEntries: NavigationEntry[] = [
        {
            id: 0,
            route: '/',
            title: 'Home',
            component: Home
        },
        {
            id: 1,
            route: '/about',
            title: 'Über uns',
            component: About
        },
        {

            id: 2,
            route: '/contact',
            title: 'Kontakt',
            component: Contact
        }
    ];

    public static readonly serviceCards: SimpleCardProperties[] = [
        {
            id: 3,
            image: (<FontAwesomeIcon icon={faCheckSquare} />),
            text: 'Durchführung sämtlicher Verfliesungsarbeiten'
        },
        {
            id: 4,
            image: (<FontAwesomeIcon icon={faClock} />),
            text: 'Fach- und termingerechte Ausführung'
        },
        {
            id: 5,
            image: (<FontAwesomeIcon icon={faEye} />),
            text: 'Aktuelle und große Auswahl an Fliesen'
        },
        {
            id: 6,
            image: (<FontAwesomeIcon icon={faUserTie} />),
            text: 'Stets kompetente Beratung für Sie'
        },
        {
            id: 7,
            image: (<FontAwesomeIcon icon={faEuroSign} />),
            text: 'Rabatte auf Fliesen und Verlegearbeiten'
        }
    ];

    public static readonly areas: string[] = [
        'Bäder',
        'Küchen',
        'Wohn- und Vorräume',
        'Stiegen',
        'Balkone',
        'Terrassen',
        'Schwimmbäder'
    ];

    public static readonly federalStates: string[] = [
        'Steiermark',
        'Kärnten',
        'Wien',
        'Tirol',
        'Burgendland',
        'Vorarlberg',
        'Niederösterreich',
        'Oberösterreich',
        'Salzburg'
    ];

    public static readonly EmailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    public static readonly NumberRegex = new RegExp(`^[0-9]*$`);
    public static readonly NameRegex = /^[a-zA-Z '.-]*$/;

    public static async saveVisit(): Promise<void> {
        const visited = localStorage.getItem('FLIESEN_SEMLITSCH_VISIT');

        if(visited == 'true'){
            const visitDate = new Date(localStorage.getItem('FLIESEN_SEMLITSCH_VISIT_DATE')!);
            const today = new Date();

            if(visitDate.getDay() == today.getDay() && visitDate.getMonth() == today.getMonth() && visitDate.getFullYear() == today.getFullYear()){
                return;
            }
        }

        const url: string = `${window.location.protocol}//${window.location.hostname}/stats.php`;

        fetch(url, {
            method: 'POST',
            mode: 'no-cors'
        }).then(() => {
            localStorage.setItem('FLIESEN_SEMLITSCH_VISIT', 'true');
            localStorage.setItem('FLIESEN_SEMLITSCH_VISIT_DATE', new Date().toISOString());
        });
    }
}

export const useWindowSize = () => {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  }